<section fxLayout="column" fxLayoutAlign="start center">
  <div class="rounded404">404</div>
  <div class="underbar uk-flex uk-flex-center"></div>
  <h3>We couldn't find the page you're looking for</h3>
  <p>
    Sorry but the page you are looking for does not exists, has been removed,
    has changed names, or it's temporarily unavailable.
  </p>
  <button mat-raised-button color="primary" (click)="onGoBack()">Back</button>
</section>
